import React from 'react';
import {
  View,
  StyleSheet,
} from 'react-native';
import { Text } from '@/components/common/text';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';
import { ConvenienceFeesDisplay } from '@/components/residents/payments/mobile/makePayment';
import { PaymentOptionButton } from './shared';
import type { FeeStructure } from '@/types/residents/payment';

interface AddPaymentMethodContentProps {
  onSelectCard: () => void;
  onSelectACH: () => void;
  feeStructure: FeeStructure;
}

/**
 * Add Payment Method Content - Displays payment type options
 */
export const AddPaymentMethodContent: React.FC<AddPaymentMethodContentProps> = ({
  onSelectCard,
  onSelectACH,
  feeStructure,
}) => {
  const MARKETPLACE_COLORS = useMarketplaceColors();
  return (
    <View style={styles.container}>
      <View style={styles.content}>
        {/* Instructions */}
        <Text style={[styles.instructionText, { color: MARKETPLACE_COLORS.textPrimary }]}>
          Please choose the type of payment you wish to use
        </Text>

        {/* Payment Type Options */}
        <View style={styles.optionsContainer}>
          <PaymentOptionButton
            label="Credit or debit card"
            onPress={onSelectCard}
          />
          <PaymentOptionButton
            label="ACH bank transfer"
            onPress={onSelectACH}
          />
        </View>
      </View>

      {/* Convenience Fees Section */}
      <ConvenienceFeesDisplay feeStructure={feeStructure} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  content: {
    paddingHorizontal: 24,
    paddingVertical: 24,
    gap: 16,
  },
  instructionText: {
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 24,
  },
  optionsContainer: {
    gap: 16,
  },
});

export default AddPaymentMethodContent;
